import { createRouteRef } from '@backstage/core-plugin-api';

export const clusterRouteRef = createRouteRef({
  id: 'cluster-management',
});

export const clusterAppRouteRef = createRouteRef({
  id: 'cluster-application',
});

export const clusterAppDetailRouteRef = createRouteRef({
  id: 'cluster-application-detail',
  params: ['applicationId'],
});
